import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { useNuovoRistoranteQuery } from "../../generated/graphql";
import { FlexContainer, MainContainer } from "./components/mainContainer";
import styled from "styled-components";
import { FancyButton } from "./components/button";
import { FancyTitle } from "./components/fancyTitle";
const Container = styled(MainContainer)`
  & > img {
    width: 100%;
    height: auto;
    max-width: 250px;
    object-fit: contain;
    margin-bottom: 20px;
  }
  padding: 50px 100px;
  box-sizing: border-box;
  p {
    max-width: 40ch;
    text-align: center;
  }
  position: relative;
`;
const HorizontalLineBottom = styled.div`
  position: absolute;
  background-color: #a2a087;

  bottom: 50px;
  right: 0;
  width: 200px;
  height: 2px;
  @media screen and (max-width: 900px) {
    display: none;
  }
`;
const HorizontalLineTop = styled(HorizontalLineBottom)`
  top: 50px;
  left: 0;
`;

const ImgTextCt = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
  @media screen and (max-width: 1200px) {
    flex-direction: column;
    align-items: center;
  }
`;
const ImgBlock = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
  & > img {
    width: 100%;
    height: auto;
    max-width: 250px;
    object-fit: contain;
    margin-bottom: 20px;
  }
  @media screen and (max-width: 900px) {
    flex-direction: column;
    align-items: center;
  }
`;
const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export function BannerRestaurant() {
  const { data } = useNuovoRistoranteQuery();
  const { data: urlsData } = useNuovoRistoranteQuery();

  return (
    <FlexContainer>
      <Container>
        <img src="/kum/logo.webp"></img>

        <ImgTextCt>
          <ImgBlock>
            <img
              src={
                urlsData?.nuovoRistorante?.imgsBannerCollection?.items[0]
                  ?.url || ""
              }
            />
            <img
              src={
                urlsData?.nuovoRistorante?.imgsBannerCollection?.items[1]
                  ?.url || ""
              }
            />
          </ImgBlock>
          <TextBlock>
            <FancyTitle double text={"RISTORAZIONE"}></FancyTitle>
            <p>
              {documentToReactComponents(
                data?.nuovoRistorante?.bannerTesto?.json,
              )}
            </p>
            <a href="/ristorante">
              <FancyButton>SCOPRI</FancyButton>
            </a>
          </TextBlock>
        </ImgTextCt>
        <HorizontalLineBottom />
        <HorizontalLineTop />
      </Container>
    </FlexContainer>
  );
}
